var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"py-3"},[_vm._v("Sigfox Dashboard")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }